import page from 'page'
import appStarterPg from '../../config/app-starter-pg.js'
import { contentElementId } from '../../config/config.js'
import { browserAppUser } from '../../helpers/app-data-loaders/app-user.js'

import { adminEntitiesRoutes } from './entities/routes.js'
import { adminEntityRoutes } from './entity/routes.js'
import { setupDataSyncsRoutes } from './data-syncs/routes.js'
import { showAdminHome } from './home/index.js'

export default function adminRoutes (baseRoute) {
  adminEntityRoutes(baseRoute + '/entity')
  adminEntitiesRoutes(baseRoute + '/entities')
  setupDataSyncsRoutes(baseRoute + '/data-syncs')

  page(`${baseRoute}/`, async function () {
    console.log(`${baseRoute}/`)
    await appStarterPg()

    showAdminHome({
      containerElementId: contentElementId,
      browserAppUser
    })
  })
}
